// As Seen On JS
document.addEventListener('DOMContentLoaded', function () {
  var swiperWrappers = document.querySelectorAll('.as-seen-on .swiper-wrapper');
  if (!swiperWrappers.length) return;
  swiperWrappers.forEach(function (swiperWrapper) {
    var swiperContainer = swiperWrapper.closest('.swiper-container');
    if (!swiperContainer) return;
    var bannerInterval = swiperWrapper.getAttribute('data-interval');
    var bannerSpeed = swiperWrapper.getAttribute('data-transition');
    const navEl = swiperContainer.querySelector('.swiper-button-next');
    window.luxoRunNearElement(swiperContainer, function () {
      const onSlideChange = (swiper) => {
        if (swiper.isBeginning)
          swiper.navigation.prevEl?.classList?.add('swiper-button-disabled', 'hidden');
        else
          swiper.navigation.prevEl?.classList?.remove('swiper-button-disabled', 'hidden');
        if (swiper.isEnd)
          swiper.navigation.nextEl?.classList?.add('swiper-button-disabled', 'hidden');
        else
          swiper.navigation.nextEl?.classList?.remove('swiper-button-disabled', 'hidden');
      }
      window.luxoLoadSwiper().then(function () {
        try {
          new Swiper(swiperContainer, {
            slidesPerView: 5,
            spaceBetween: 0,
            loop: true, // Enables infinite scrolling
            autoplay: {
              delay: bannerInterval,
              disableOnInteraction: false,
            },
            speed: bannerSpeed,
            breakpoints: {
              500: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 5,
                spaceBetween: 10,
              },
              1200: {
                slidesPerView: 10,
                spaceBetween: 10,
              }
            },
            centerInsufficientSlides: true,
            navigation: navEl ? {
              nextEl: '.as-seen-on-carousel__nav--next',
              prevEl: '.as-seen-on-carousel__nav--prev',
            } : false,
            on: {
              init: function () {
                onSlideChange(this);
              },
              slideChange: onSlideChange
            }
          });
        } catch (error) { }
      });
    });
  });
});
